import { MODE_RECEPTION } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case MODE_RECEPTION.ANTENNE_RATEAU:
        return 'Antenne râteau';
      case MODE_RECEPTION.ANTENNE_INTERIEURE:
        return 'Antenne intérieure';
      case MODE_RECEPTION.ADSL_FIBRE:
        return 'ADSL/Fibre';
      case MODE_RECEPTION.PARABOLE:
        return 'Parabole satellite';
      case MODE_RECEPTION.CABLE:
        return 'Câble';
      case MODE_RECEPTION.AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/accueil/filters/mode-reception.filter.js